import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { faqslist, deletefaqs } from "../../service/Mainservice";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from "@mui/icons-material/Search";
import Deletepopup from "./Aresure";
import { Alert, Snackbar } from "@mui/material";
import Loader from "../../Loader/Loader";
import ListControls from "../ListControls/ListControls";
import Pagination from "../Pagination/pagination";

const FAQSList = () => {
  const [loading, setloading] = useState(true);
  const [data, setData] = useState([]);
  const [addinterview, setaddinterview] = useState(false);
  const [showdelete, setshowdelete] = useState(false);
  const [id, setid] = useState(false);
  const [open, setOpen] = useState(false);
  const [err, seterror] = useState("");
  const [pagination, setpagination] = useState({ page: 1 });
  const [searchvalue, setsearchvalue] = useState("");
  const [sortBy, setSortBy] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");

  const navigate = useNavigate();

  useEffect(() => {
    getData(1);
  }, [searchvalue, sortBy, sortOrder]);

  const getData = async (page = 1) => {
    try {
      const response = await faqslist(searchvalue, { page, pageSize: 10, sortBy, sortOrder });
      console.log(response);
      console.log("-----------response.data.data-----------");
      console.log(response.data.data);
      const idsToRemove = [3, 4, 5, 6, 10, 20, 18, 12, 13, 17, 19];
      setData(
        response.data.data.filter((item) => !idsToRemove.includes(item.id))
      );
      // setData(response.data.data);
      setpagination(response.data.pagination || { page, limit: 10, total: 0 });

      setloading(false);
    } catch (error) {
      setloading(false);
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const handlePageChange = (pageNumber) => {
    getData(pageNumber);
  };

  const handlesearch = async (e) => {
    setsearchvalue(e.target.value);
    getData(1, e.target.value);
  };

  const handledelete = async () => {
    try {
      const response = await deletefaqs(id);
      getData("1");
      setshowdelete(false);
    } catch (error) {
      seterror(error.message);
      setOpen(true);
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
      setshowdelete(false);
    }
  };

  const onClose = () => {
    setshowdelete(false);
    // navigate("/Room");
  };
  console.log(data);
  return (
    <>
      <div className="container1">
        <div className="data_head">
          <h1 className="data_heading">FAQs</h1>
          <div className="data_headdown">
            <h1 className="data_add" onClick={() => navigate("/Add_FAQS")}>
              <AddIcon /> Add FAQs
            </h1>

            <div className="searchicon">
              <SearchIcon />
              <input
                type="search"
                placeholder="Search..."
                id="search"
                onChange={handlesearch}
              />
            </div>
          </div>
        </div>
        <ListControls sortOptions={[{value:"createdAt",label:"Created date"},{value:"question",label:"Question"},{value:"category",label:"Category"}]} sortBy={sortBy} sortOrder={sortOrder} onSortByChange={setSortBy} onSortOrderChange={setSortOrder} />
        {data.length > 0 ? (
          <>
            <div className="data_table_over">
              <table className="data_table">
                <thead>
                  <tr>
                    <th>Question</th>
                    <th>Answer</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item) => {
                    return (
                      <tr key={item.id}>
                        <td>{item.question}</td>
                        <td>{item.answer}</td>
                        <td>
                          {/* <button
                      // onClick={() => navigate("/User_Details")}
                      className="data_button_view"
                    >
                      View
                    </button> */}
                          <div style={{ width: "70px" }}>
                            {" "}
                            <EditIcon
                              sx={{ color: "var(--red)" }}
                              onClick={() =>
                                navigate("/Edit_FAQS", {
                                  state: {
                                    item,
                                  },
                                })
                              }
                            />
                            <DeleteIcon
                              sx={{ color: "var(--red)" }}
                              onClick={() => {
                                setid(item.id);
                                setshowdelete(true);
                              }}
                            />
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <Pagination pagedata={pagination} onPageChange={getData} />
          </>
        ) : (
          <p className="nodata">No FAQs Added Yet</p>
        )}

        <Deletepopup
          isOpen={showdelete}
          setisOpen={setshowdelete}
          handledelete={handledelete}
          onClose={onClose}
        />
      </div>
      {loading && <Loader />}
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={() => setOpen(false)}
      >
        <Alert severity="error" variant="filled" sx={{ width: "70vw" }}>
          {err}
        </Alert>
      </Snackbar>
    </>
  );
};
export default FAQSList;
